module.exports = __webpack_public_path__ + "static/img/service-background.4b4e603.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/service-background.png
// module id = h6eh
// module chunks = 0